import React, { useContext, useState, useEffect } from "react";
import { ButtonComponent } from "@syncfusion/ej2-react-buttons";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ToastContext from "../Context/toastContext";
import axiosClient from "../Utils/axiosClient";
import useTitle from "../Hooks/useTitle";

const ResetPasswordPage = () => {
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState("");
  const [resetCode, setResetCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { showToast } = useContext(ToastContext);

  useTitle(`${t("Reset Password")} | Netileti`);

  useEffect(() => {
    const emailParam = searchParams.get("email");
    const tokenParam = searchParams.get("token");

    if (emailParam) setEmail(emailParam);
    if (tokenParam) setResetCode(tokenParam);
  }, [searchParams]);

  const validatePassword = (password) => {
    const errors = {};
    if (password.length < 6) {
      errors.length = `${t("Password must be at least 6 characters long")}`;
    }
    if (!/[A-Z]/.test(password)) {
      errors.uppercase = `${t(
        "Password must contain at least one uppercase letter"
      )}`;
    }
    if (!/[a-z]/.test(password)) {
      errors.lowercase = `${t(
        "Password must contain at least one lowercase letter"
      )}`;
    }
    if (!/[0-9]/.test(password)) {
      errors.number = `${t("Password must contain at least one number")}`;
    }
    if (!/[!@#$%^&*]/.test(password)) {
      errors.special = `${t(
        "Password must contain at least one special character"
      )}`;
    }
    return errors;
  };

  const resetPasswordClicked = async () => {
    const validationErrors = validatePassword(newPassword);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    if (newPassword !== confirmPassword) {
      showToast(`${t("Passwords do not match")}`, `${t("Error")}`);
      return;
    }

    try {
      const response = await axiosClient.post("/resetPassword", {
        email,
        resetCode,
        newPassword,
      });
      if (response.status === 200) {
        showToast(`${t("Password reset success")}`, `${t("Success")}`);
        setTimeout(() => {
          navigate("/");
        }, 2000);
      } else {
        showToast(`${t("Password reset failed")}`, `${t("Error")}`);
      }
    } catch (error) {
      if (error.response.data.errors?.InvalidToken) {
        showToast(
          `${t("Error")} : ${t("responseErrors.InvalidToken")}`,
          `${t("Error")}`
        );
      } else {
        showToast(`${t("Error")} : ${error.message}`, `${t("Error")}`);
      }
    }
  };

  return (
    <div className="reset-password-container">
      <div className="reset-content">
        <img className="logo-reset-password" src="/images/logo.png" alt="login-sm" />
        <input
          type="email"
          className="e-input"
          placeholder={t("E-mail")}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          readOnly
        />
        {/* <input
          type="text"
          className="e-input"
          placeholder={t("Reset Code")}
          value={resetCode}
          onChange={(e) => setResetCode(e.target.value)}
        /> */}

        <input
          type="password"
          className="e-input"
          placeholder={t("New Password")}
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
        />

        <input
          type="password"
          placeholder={t("Confirm Password")}
          value={confirmPassword}
          className="e-input"
          onChange={(e) => setConfirmPassword(e.target.value)}
        />
        {errors.length && <small>{errors.length}</small>}
        {errors.uppercase && <small>{errors.uppercase}</small>}
        {errors.lowercase && <small>{errors.lowercase}</small>}
        {errors.number && <small>{errors.number}</small>}
        {errors.special && <small>{errors.special}</small>}
        <ButtonComponent cssClass="e-primary" onClick={resetPasswordClicked}>
          {t("Reset Password")}
        </ButtonComponent>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
